module.exports = __webpack_public_path__ + "img/dp-kong.aebe6399.png";